import React, { useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, MenuItem, TextField, Grid, Typography,
  Tooltip, Link,
} from '@material-ui/core'
import { NumericFormat } from 'react-number-format'
import { useTranslation } from 'react-i18next'
import { anosBase } from 'pages/titulos-lbc/titulos-lbc.helpers'

const anos = anosBase()

const ResgatarModal = ({ titulo, unidades = [], anoBaseInicial, onFechar, onConfirmar }) => {
  const { t, i18n } = useTranslation()
  const ehPt = i18n.language === 'pt-BR'
  const [form, setForm] = useState({
    anoBase: String(anoBaseInicial || anos[1].value),
    quantidade: '',
    unidadeId: '',
  })
  const disponivel = Number(titulo.quantidadeDisponivel)
  const invalido = !(Number(form.quantidade) > 0) || Number(form.quantidade) > disponivel

  return (
    <Dialog open fullWidth maxWidth="sm" onClose={onFechar}>
      <DialogTitle>{t('resgatesLbc.resgatarTitulo')}</DialogTitle>
      <DialogContent>
        <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
          {titulo.codigo} · {titulo.ecorregiao?.nome}
        </Typography>
        <Typography variant="subtitle2" style={{ color: '#219754', fontWeight: 600 }}>
          {t('resgatesLbc.disponivel')}: {disponivel.toLocaleString(ehPt ? 'pt-BR' : 'en-US', { minimumFractionDigits: 2 })} LBC
        </Typography>
        <Grid container spacing={2} style={{ marginTop: 4 }}>
          <Grid item xs={6}>
            <Tooltip title={t('resgatesLbc.anoBaseTooltip')} arrow placement="top">
              <TextField
                select fullWidth size="small" label={t('resgatesLbc.anoBase')}
                value={form.anoBase} onChange={(e) => setForm((f) => ({ ...f, anoBase: e.target.value }))}
              >
                {anos.map((a) => <MenuItem key={a.value} value={a.value}>{a.label}</MenuItem>)}
              </TextField>
            </Tooltip>
          </Grid>
          <Grid item xs={6}>
            <NumericFormat
              customInput={TextField} fullWidth size="small" label={t('resgatesLbc.quantidade')}
              value={form.quantidade}
              thousandSeparator={ehPt ? '.' : ','} decimalSeparator={ehPt ? ',' : '.'}
              decimalScale={2} allowNegative={false}
              onValueChange={(vals) => setForm((f) => ({ ...f, quantidade: vals.floatValue ?? '' }))}
            />
            <Link
              component="button" type="button" variant="caption" underline="always"
              onClick={() => setForm((f) => ({ ...f, quantidade: disponivel }))}
              style={{ marginTop: 4, display: 'inline-block' }}
            >
              {t('resgatesLbc.resgatarTotal')}
            </Link>
          </Grid>
          <Grid item xs={12}>
            <TextField
              select fullWidth size="small" label={t('resgatesLbc.unidadeOpcional')}
              value={form.unidadeId} onChange={(e) => setForm((f) => ({ ...f, unidadeId: e.target.value }))}
            >
              <MenuItem value="">{t('resgatesLbc.alocarDepois')}</MenuItem>
              {unidades.map((u) => <MenuItem key={u.id} value={u.id}>{u.nome}</MenuItem>)}
            </TextField>
          </Grid>
        </Grid>
        <Typography variant="caption" style={{ display: 'block', marginTop: 10 }}>
          {t('resgatesLbc.regra30', { ecorregiao: titulo.ecorregiao?.nome })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onFechar}>{t('inputs.cancelar')}</Button>
        <Button
          color="primary" variant="contained" disabled={invalido}
          onClick={() => onConfirmar({
            anoBase: form.anoBase,
            quantidade: Number(form.quantidade),
            unidadeId: form.unidadeId || undefined,
          })}
        >
          {t('resgatesLbc.confirmarResgate')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ResgatarModal
